import styled from 'styled-components'

export const ExplorerTxLink = styled.a`
  color: var(--link-color);
  text-decoration: underline;
  font-weight: bold;
`
